import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Details/{id}',
  alias: ['/sistema/crm/Oportunidad/Details'],
  documento: 'crm',
  filas: ['137'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:569',
} satisfies RutaProd;
